var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFavicon32 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    d: "M0 12c0-4.2 0-6.3.817-7.905.72-1.411 1.867-2.558 3.278-3.278C5.7 0 7.8 0 12 0h8c4.2 0 6.3 0 7.905.817 1.411.72 2.558 1.867 3.277 3.278C32 5.7 32 7.8 32 12v8c0 4.2 0 6.3-.817 7.905-.72 1.411-1.867 2.558-3.278 3.277C26.3 32 24.2 32 20 32h-8c-4.2 0-6.3 0-7.905-.817-1.411-.72-2.558-1.867-3.278-3.278C0 26.3 0 24.2 0 20v-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.87 10.518c.577-.52 1.466-.474 1.987.102l6.25 6.928.017 1.864-6.25 7.188c-.51.586-1.398.648-1.984.138-.586-.51-.648-1.398-.139-1.984l5.433-6.247-5.416-6.003c-.52-.576-.474-1.465.102-1.986z",
    clipRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.643 26.378c.52.577 1.41.623 1.986.103.577-.52.623-1.41.103-1.987l-5.416-6.002 5.433-6.247c.51-.586.447-1.475-.139-1.984-.586-.51-1.474-.448-1.984.138l-5.501 6.327v3.536l5.518 6.116z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    d: "M16.125 16.313H16.375V20.938H16.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.375 11.104c1.06 0 2.078-.422 2.828-1.172s1.172-1.768 1.172-2.828c0-1.061-.421-2.079-1.172-2.829-.75-.75-1.767-1.171-2.828-1.171v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.375 11.104c-1.06 0-2.078-.422-2.828-1.172s-1.172-1.768-1.172-2.828c0-1.061.421-2.079 1.172-2.829.75-.75 1.767-1.171 2.828-1.171v8z",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H32V32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd",
    width: 432,
    height: 432,
    x: -250,
    y: -150,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.47451 0 0 0 0 0.317647 0 0 0 0 0.215686 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -32,
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.475 0 0 0 0 0.31825 0 0 0 0 0.21375 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -50,
    dy: 50
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.47451 0 0 0 0 0.317647 0 0 0 0 0.215686 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavicon32, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Favicon_32.e7431308.svg";
export { ForwardRef as ReactComponent };